import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Get in Touch`}</h1>
    <p>{`Connect with me on `}<a parentName="p" {...{
        "href": "https://twitter.com/anu_71199"
      }}>{`Twitter`}</a>{`, `}<a parentName="p" {...{
        "href": "https://github.com/anushree71199"
      }}>{`Github`}</a>{`, `}<a parentName="p" {...{
        "href": "https://www.linkedin.com/in/anushree-chatterjee-95990316a/"
      }}>{`LinkedIn`}</a>{`!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      